import { Route } from '@/app/router'

const Order = () => import('./index.vue')

export default new Route('/orders/:id', Order).as('Dashboard:Order').permissions(['VIEW_ORDER'])
